import LiveRewardsList from './List';

const LiveRewardsIndex = {
  LiveRewardsList, 
};

export default LiveRewardsIndex;